/**
 * @fileName：action-axios_ly
 * @author : hongye.liu
 * @DATE :  2018/7/3
 * @intro:
 */

import Vue from 'vue';
import store from '../store';

const vue = new Vue({
	store
});
